import React from 'react';

import './styles.scss';

import Logo from '../../assets/svg/logo.svg';
import GitHubIcon from '../../assets/svg/github.svg';

class Footer extends React.Component {
    render() {
        return (
            <div className="footer">
                <div className="footer-container">
                    <img className="logo" src={Logo}/>
                    <h1 className="logo">Scattered Corp</h1>
                    
                    <div className="navigation">
                        <ul>
                            <li>
                                <a href="/">Download</a>
                            </li>
                            <li>
                                <a href="https://docs.scatteredcorp.tech/#/">Documentation</a>
                            </li>
                            <a rel="noopener noreferrer" href="mailto:contact@scatteredcorp.tech">
                                Contact
                            </a>
                        </ul>
                    </div>
                    
                    <div>
                        <a rel="noopener noreferrer" className="icon" target="_blank" href="https://github.com/scatteredcorp">
                            <img alt="github" src={GitHubIcon}/>
                        </a>

                        <span className="copyright">
                            BilleGateCoin - {new Date().getFullYear()} 
                        </span>
                    </div>
                </div>
            </div>
        )
    }
}

export default Footer;